import { connect } from 'react-redux';
import { alignLogoToChest, centerLogo } from '../../../../../../../../redux/logo/logo.actions';
import CenterLogo from './center-logo';
const mapDispatchToProps = dispatch => {
  return {
    onClickAlignCenter: () => {
      dispatch(centerLogo());
    },
    onClickAlignLeft: () => {
      dispatch(alignLogoToChest('left'));
    },
    onClickAlignRight: () => {
      dispatch(alignLogoToChest('right'));
    }
  };
};
export default connect(null, mapDispatchToProps)(CenterLogo);